import { useAuthContext } from '@/contexts/AuthContext';

export type { AccessTokenPayload } from '@/api/auth/interfaces';

/**
 * Primary auth hook for the application. Returns the current user's decoded
 * JWT and helpers to reload or clear the session.
 *
 * Reads from {@link AuthProvider} context, so every caller shares the same
 * auth state — no duplicate cookie reads or brief "logged out" flashes
 * while a separate instance loads.
 *
 * @example
 * const { payload, loading, isAuthenticated } = useAuth();
 * if (loading) return <Spinner />;
 * if (!isAuthenticated) return <LoginPrompt />;
 */
export function useAuth() {
  const { user, loading, reload, clearAuth, isAuthenticated } = useAuthContext();
  return {
    /** Decoded JWT payload (alias for context `user`). */
    payload: user,
    loading,
    reload,
    clearAuth,
    isAuthenticated
  };
}
